import React from "react";
import { ModalTemplate } from "../../templates/ModalTemplate";
import { OwnerForm, OwnerFormData } from "../form/OwnerForm";
import { useOwnerToast, useOwnerRegistration } from "../../pages/owners/hook";
import { Toast } from "../../atoms/Toast";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit?: (data: OwnerFormData) => void;
  refetchOwners?: () => void;
};

export const CreateOwnerModal: React.FC<Props> = ({
  isOpen,
  onClose,
  onSubmit,
  refetchOwners
}) => {
  const { toast, showToast, hideToast } = useOwnerToast();
  const { handleRegisterOwner } = useOwnerRegistration(showToast, refetchOwners, onClose);

  const handleFormSubmit = (data: OwnerFormData, onError: (message: string) => void) => {
    handleRegisterOwner(
      {
        name: data.name,
        email: data.email,
        phone_number: data.phoneNumber,
        other_phone_number: data.otherPhoneNumber,
      },
      onError,
      () => {
        onSubmit?.(data);
      }
    );
  };

  if (!isOpen) return null;

  return (
    <div>
      {toast.visible && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={hideToast}
        />
      )}
      <ModalTemplate
        isOpen={isOpen}
        title="Create Owner"
        onClose={onClose}
      >
        <OwnerForm key={isOpen ? 'open' : 'closed'} handleSubmit={handleFormSubmit} />
      </ModalTemplate>
    </div>
  );
};
